import React, { useState } from 'react';
import '../styles/pages/OtherPrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const OtherPrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const otherTypes = [
    {
      id: 1,
      title: "Pen Printing",
      icon: "🖊️",
      description: "Custom printed pens for branding and promotional purposes. High-quality printing on various pen styles and colors.",
      features: [
        "Custom logo printing",
        "Multiple pen styles",
        "Bulk quantities",
        "High-quality ink",
        "Various colors",
        "Comfortable grip"
      ],
      specifications: {
        material: "Plastic, metal pens",
        thickness: "Standard pen size",
        width: "Standard pen dimensions",
        durability: "Long-lasting ink",
        applications: "Corporate gifts, promotions"
      },
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=500&h=350&fit=crop", // Pen printing image
      color: "#6366f1",
      bestFor: ["Corporate branding", "Promotional items", "Events", "Giveaways"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Keyring Printing",
      icon: "🔑",
      description: "Custom keyrings with your logo or design. Durable materials and high-quality printing for promotional and branding needs.",
      features: [
        "Custom designs",
        "Durable materials",
        "Various shapes",
        "High-quality printing",
        "Bulk discounts",
        "Quick production"
      ],
      specifications: {
        material: "Metal, plastic, leather",
        thickness: "Varies by type",
        width: "Standard keyring size",
        durability: "Scratch-resistant",
        applications: "Promotional items, gifts"
      },
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=500&h=350&fit=crop", // Keyring printing image
      color: "#f59e0b",
      bestFor: ["Corporate gifts", "Event promotions", "Branding", "Customer loyalty"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Photo Frame",
      icon: "🖼️",
      description: "Custom photo frames with personalized printing. Perfect for gifts, corporate branding, and decorative purposes.",
      features: [
        "Custom sizes",
        "Various frame materials",
        "Personalized printing",
        "High-quality glass",
        "Elegant designs",
        "Bulk orders"
      ],
      specifications: {
        material: "Wood, plastic, metal frames",
        thickness: "Varies by size",
        width: "Standard photo sizes",
        durability: "Durable construction",
        applications: "Gifts, decorations, branding"
      },
      image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=500&h=350&fit=crop", // Photo frame image
      color: "#10b981",
      bestFor: ["Corporate gifts", "Personalized gifts", "Home decor", "Event favors"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="other-printing-page">
      <HeroSection
        heroTitle="Other Printing Services"
        heroSubtitle="Discover our diverse range of custom printing solutions. From promotional pens to personalized photo frames, we bring your ideas to life."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={otherTypes}
        title="Our Premium Other Printing Solutions"
        subtitle="Discover our diverse range of custom printing solutions. From promotional pens to personalized photo frames, we bring your ideas to life."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={otherTypes.map(otherType => ({
          id: otherType.id,
          title: otherType.title,
          icon: otherType.icon,
          gallery: otherType.portfolio?.gallery || []
        }))}
        title="Our Other Printing Portfolio"
        subtitle="Explore our premium other printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default OtherPrinting;
